import { AgGridReact } from "ag-grid-react";
import "../VendorFollowUp.scss";
import "ag-grid-enterprise"; // Import Ag-Grid Enterprise features
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import {useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import EmailModal from "./EmailModel/EmailModel";
import Navbar from "./Navbar/Navbar";
import { useRecoilState } from "recoil";
import { workspaceInfo } from "app/config/States/users";
import UploadContactsModal from "./UploadContactModel/UploadContactsModal";
import EmailConfirmationModel from "./EmailConfirmation/EmailConfirmation";
import MainContentVendor from "./VendorScore/pages/demo/MainContent/MainContent";
import './App.css'
import { API_ENDPOINT_GET_USER_INFO } from "app/scenes/Auth/auth.constants";
import { apiGet } from "app/services/apiServices";

const VendorFollowupList = () => {
  const [vendorData, setVendorData] = useState([]);
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [SelectedVendor, setSelectedVendor] = useState(null);
  const [SelectedGstin, setSelecteGstin] = useState(null);
  const [IN, setSelectedIN] = useState(null);
  const [ID, setSelectedID] = useState(null);
  const [gstData, setGstData] = useState([]);


  const [roleType, setRoleType] = useState('');
  const [totalVendors, setTotalVendors] = useState(0);
  const [totalGSTRows, setTotalGSTRows] = useState(0);
  const [missingContactCount, setMissingContactCount] = useState(0);
  const [compliantVendors, setCompliantVendors] = useState(0);
  const [nonCompliantVendors, setNonCompliantVendors] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [allVendorData, setAllVendorData] = useState([]);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const openEmailModal = () => setIsEmailModalOpen(true);
  const closeEmailModal = () => setIsEmailModalOpen(false);
  const [isEmailConfirmationModelOpen, setIsEmailConfirmationModelOpen] = useState(false);
  

  const [workspaces, setWorkspaces] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isVendorManagement, setIsVendorManagement] = useState(false); // Default to Vendor Management


  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [columnDefs, setColumnDefs]=useState([])
  const [isContactDetails, setIsContactDetails] = useState(true);
  


  const handleSendInvite = () => {
    // Update the rows state to reflect the 'Mail Sent' action
    setVendorData(prevState => 
      prevState.map(row => 
        row.gstin === SelectedGstin && row.vendorName === SelectedVendor
          ? { ...row, action: 'Mail Sent' }  // Update the action field
          : row
      )
    );
  
    // Close the email modal
    setIsEmailModalOpen(false);

    setIsEmailConfirmationModelOpen(true);
    console.log("Email Model opened");
    

  };

  
  

 

  const [isUploadContactsModalOpen, setUploadContactsModalOpen] = useState(false);

  const openUploadContactsModal = () => setUploadContactsModalOpen(true);
  const closeUploadContactsModal = () => setUploadContactsModalOpen(false);

  const [contactData, setContactData] = useState([]); // Add this state for contact data



  const [workspace, setWorkspace] = useRecoilState(workspaceInfo);

  const [selectedWorkspace, setSelectedWorkspace] = useState(
    workspace || null
  );

  const columnDefsTwoB = [
    // Enable row grouping for Vendor Name
   //  {headerName:"Id",field:"_id"},
  
  
    
   { headerName: "Vendor name", field: "enablement.legalNm]",width:400,
     cellStyle: { color: "#0A8394", textDecoration: "underline" },checkboxSelection: true,headerCheckboxSelection: true,
     cellRenderer: (params) => {
      // Check if enablement is an array and has at least one element
      if (params.data && Array.isArray(params.data.enablement) && params.data.enablement.length > 0) {
        // Return the 'legalNm' from the first element of the enablement array
        return params.data.enablement[0].legalNm;
      }
      return ''; // If no value or empty array, return an empty string
    }
    },
   { headerName: "GSTIN", field: "gstin",
     //  cellRenderer: (params) => {
     //      if (!params.node.group && params.colDef.field === "gstin") {
     //        return params.data.gstin
     //      }
     //      return "";
     //    },
  
  },
   { headerName: "PAN", field: "pan", 
     // cellRenderer: (params) => {
     //   console.log("************************************",params)
     //   if (!params.node.group && params.colDef.field === "pan") {
     //     return params.data.pan
     //   }
     //   return "";
     // },
   },
   { headerName: "Eligibility Status", field: "einvoiceEligibility", cellRenderer: renderEInvoice1, },
   { headerName: "Invoice Status", field: "invoiceStatus",
   //   cellRenderer: (params) => {
   //   console.log("************************************",params)
   //   if (!params.node.group && params.colDef.field === "invoiceStatus") {
   //     return params.data.invoiceStatus
   //   }
   //   return "";
   // },
 },
 

  {
   headerName: "FollowUp", 
   field: "followUp",
   floatingFilter: true,
   filter: 'agTextColumnFilter',
   enableRowGroup: true,
   cellRenderer: (params) => {
     // For parent group rows (grouped, collapsed state)
     if (params.node.group) {
       return params.value || "Grouped FollowUp"; // Display the group value or fallback text
     }
  
     // For child rows (expanded level)
     if (!params.node.group && params.node.parent) {
       return params.data?.followUp || "No FollowUp Data"; // Display followUp for child rows
     }
  
     // Default case: For other columns, return empty
     return null;
   },
   hide: (params) => {
     if (params.node && params.node.group) {
       return true; // Hide the column for group rows
     }
  
     // For expanded child rows, we want the column to be visible
     return false;
   }
  },
  { headerName: "Trade name", field: "enablementTradeNm", sortable: true,floatingFilter: true,filter: 'agTextColumnFilter',width:400  },
  
  
   {
     headerName: "Invoice Number",
     field: "inum",
     //aggFunc: 'count',
     cellRenderer: (params) => {
       console.log("************************************",params)
       if (!params.node.group && params.colDef.field === "inum") {
         return params.data.inum
       }
       return "";
     },
   },
 
   {
     headerName: "HSN",
     field: "HSN",
     //aggFunc: 'count',
     cellRenderer: renderHSN
   },
 
   // { headerName: "Contact details", field: "contact", cellRenderer: renderContact, floatingFilter: true, filter: 'agTextColumnFilter', pinned: "right" },
   // { headerName: "Action", field: "action", cellRenderer: renderAction, floatingFilter: true, filter: 'agTextColumnFilter', cellStyle: { color: "#0A8394" }, pinned: "right" },
  ];
 const columnDefsTwoA = [
   // Enable row grouping for Vendor Name
  //  {headerName:"Id",field:"_id"},
 
 
   
  { headerName: "Vendor name", field: "enablement.legalNm",width:400,
    cellStyle: { color: "#0A8394", textDecoration: "underline" },checkboxSelection: true,headerCheckboxSelection: true,
    // cellRenderer: (params) => {
    //   console.log("************************************",params)
    //   if (!params.node.group && params.colDef.field === "enablement.legalNm") {
    //     return params.data.enablement
    //   }
    // }
   },
  { headerName: "GSTIN", field: "gstin",
    //  cellRenderer: (params) => {
    //      if (!params.node.group && params.colDef.field === "gstin") {
    //        return params.data.gstin
    //      }
    //      return "";
    //    },
 
 },
  { headerName: "PAN", field: "pan", 
    // cellRenderer: (params) => {
    //   console.log("************************************",params)
    //   if (!params.node.group && params.colDef.field === "pan") {
    //     return params.data.pan
    //   }
    //   return "";
    // },
  },
  { headerName: "Eligibility Status", field: "einvoiceEligibility", cellRenderer: renderEInvoice1, },
  { headerName: "Invoice Status", field: "invoiceStatus",
  //   cellRenderer: (params) => {
  //   console.log("************************************",params)
  //   if (!params.node.group && params.colDef.field === "invoiceStatus") {
  //     return params.data.invoiceStatus
  //   }
  //   return "";
  // },
},

 
 {
  headerName: "FollowUp", 
  field: "followUp",
  floatingFilter: true,
  filter: 'agTextColumnFilter',
  enableRowGroup: true,
  cellRenderer: (params) => {
    // For parent group rows (grouped, collapsed state)
    if (params.node.group) {
      return params.value || "Grouped FollowUp"; // Display the group value or fallback text
    }
 
    // For child rows (expanded level)
    if (!params.node.group && params.node.parent) {
      return params.data?.followUp || "No FollowUp Data"; // Display followUp for child rows
    }
 
    // Default case: For other columns, return empty
    return null;
  },
  hide: (params) => {
    if (params.node && params.node.group) {
      return true; // Hide the column for group rows
    }
 
    // For expanded child rows, we want the column to be visible
    return false;
  }
 },
 { headerName: "Trade name", field: "enablementTradeNm", sortable: true,floatingFilter: true,filter: 'agTextColumnFilter',width:400  },
 
 
  {
    headerName: "Invoice Number",
    field: "inum",
    //aggFunc: 'count',
    cellRenderer: (params) => {
      console.log("************************************",params)
      if (!params.node.group && params.colDef.field === "inum") {
        return params.data.inum
      }
      return "";
    },
  },

  {
    headerName: "HSN",
    field: "HSN",
    //aggFunc: 'count',
    cellRenderer: renderHSN
  },

  // { headerName: "Contact details", field: "contact", cellRenderer: renderContact, floatingFilter: true, filter: 'agTextColumnFilter', pinned: "right" },
  // { headerName: "Action", field: "action", cellRenderer: renderAction, floatingFilter: true, filter: 'agTextColumnFilter', cellStyle: { color: "#0A8394" }, pinned: "right" },
 ];


  const [is2A, setIs2A] = useState(true); // State for the toggle (default: 2A)

  const toggleTableTwoATwoB = () => {
    console.log("toggleTableTwoATwoB")
    setIs2A(!is2A); // Toggle between 2A and 2B
  };


  useEffect(() => {
    if (is2A) {
      setColumnDefs(columnDefsTwoA); // Use "Twoa" columnDefs
    } else {
      setColumnDefs(columnDefsTwoB); // Use "Twob" columnDefs
    }
  }, [is2A]);



  useEffect(() => {
    if (gridApi) {
      console.log("Initializing datasource for workspace:", is2A ? "2A" : "2B");
     
      const datasource = is2A
        ? getServerSideDatasourceTwoa(workspace)
        : getServerSideDatasourceTwob(workspace);
      gridApi.setServerSideDatasource(datasource);
    }
  }, [gridApi, is2A,workspace]);

  useEffect(() => {
    if (isContactDetails) {
      setColumnDefs(columnDefsContactDetails);
      callContactDetailsAPI(); // Set the server-side datasource for Contact Details
    }
  }, [isContactDetails]);

  const callContactDetailsAPI = () => {
    console.log("Calling API for Contact Details");
    
    if (gridApi) {
      console.log("Setting server-side datasource for Contact Details");
      const datasource = getServerSideDatasourceContactDetails(workspace); // Call the provided datasource function
      gridApi.setServerSideDatasource(datasource);
    } else {
      console.error("Grid API is not initialized!");
    }
  };


  function renderHSN(params) {
    if (!params.data || !params.data.HSN) {
      console.log("HSN Data Missing for Row:", params.data);
      return ''; // Return empty if no HSN data
    }
  
    const { HSN } = params.data;
    let hsnCodes = [];
  
    // Extract codes from bzgddtls
    if (HSN.bzgddtls && HSN.bzgddtls.length > 0) {
      hsnCodes = hsnCodes.concat(HSN.bzgddtls.map(item => item.hsncd));
    }
  
    // Extract codes from bzsdtls
    if (HSN.bzsdtls && HSN.bzsdtls.length > 0) {
      hsnCodes = hsnCodes.concat(HSN.bzsdtls.map(item => item.saccd));
    }
  
    const formattedHSN = `{${hsnCodes.join(', ')}}`;
    console.log("Formatted HSN Codes:", formattedHSN); // Log the formatted output
    return formattedHSN; // Wrap all codes in one set of curly braces
  }
  
  


  const detailColumnDefs = [
    { headerName: "HSN Code", field: "HsnCd" },
    { headerName: "HSN Description", field: "PrdDesc" }
  ];



  // const decodedWorkspace = decodeURIComponent(workspace);
  const [loading, setLoading] = useState(true); // Loader state





  const getDetailRowData = (params) => {
    console.log("Row Data for Detail: ", params.data);
  
    // Ensure params.data exists and then check for Hsn_Irn
    if (params.data && params.data.Hsn_Irn && Array.isArray(params.data.Hsn_Irn) && params.data.Hsn_Irn.length > 0) {
      console.log("Detail Row Data:", params.data.Hsn_Irn);
      params.successCallback(params.data.Hsn_Irn);
    } else {
      console.log("No Hsn_Irn data found, passing empty array");
      params.successCallback([]);  // Ensure empty array is passed if no data found
    }
  };

  const onRowGroupOpened = (event) => {
    if (event.node && event.node.expanded && Array.isArray(event.node.allLeafChildren)) {
      // Safely map over allLeafChildren if it's an array
      const expandedData = event.node.allLeafChildren.map((child) => child.data);
      
      console.log("Expanded Row Data:", expandedData);
  
      // Call your print function here
      printExpandedRowData(expandedData);
    } else {
      console.log("No leaf children found or node is not expanded.");
    }
  };

  // const gstColumnDefs = [
  //   // { headerName: "Vendor Name", field: "vendorName", sortable: true, filter: true },
  //   { headerName: "Vendor Name", field: "vendorName", sortable: true,floatingFilter: true,filter: 'agTextColumnFilter',checkboxSelection: true,headerCheckboxSelection: true, width:350,
  //     cellStyle: { color: "#0A8394", textDecoration: "underline" },
  //     aggFunc: (params) => {
  //       // Check if params.values is an array and has values
  //       if (Array.isArray(params.values) && params.values.length > 0) {
  //         const uniqueValues = [...new Set(params.values)];
    
  //         // If all values in the group are the same, return the value
  //         return uniqueValues.length === 1 ? uniqueValues[0] : '';
  //       }
  //       return ''; // Return empty string if values is not an array or is empty
  //     },
  //   },
  //   { headerName: "PAN", field: "pan", sortable: true, filter: true },
  //   { headerName: "GSTIN", field: "gstin", sortable: true, filter: true },
  //   { headerName: "Email", field: "contactEmail", sortable: true, filter: true,width:400 },
  //   { headerName: "E-invoice eligible", field: "einvoiceEligibility", cellRenderer: renderEInvoice1,floatingFilter: true,filter: 'agTextColumnFilter',
  //     filterParams: {
  //       filterOptions: ['equals'], // Allow exact match filtering
  //       textFormatter: (value) => {
  //         return value === 'Y' 
  //           ? 'True' 
  //           : value === 'N' 
  //           ? 'False' 
  //           : value === 'Einvoice Exempt' 
  //           ? 'Exempt' 
  //           : ''; // Format as True/False/Exempt
  //       }
  //     },
      
  //   },
  //   { headerName: "HSN", field: "HSN", cellRenderer: renderHSN, sortable: true, floatingFilter: true, filter: 'agTextColumnFilter',width:600 },
  // ];
  
  
  


  const columnDefsContactDetails = [
    { headerName: "Vendor name", field: "vendorName", sortable: true,floatingFilter: true,filter: 'agTextColumnFilter',checkboxSelection: true,headerCheckboxSelection: true, width:350,
      cellStyle: { color: "#0A8394", textDecoration: "underline" },
      aggFunc: (params) => {
        // Check if params.values is an array and has values
        if (Array.isArray(params.values) && params.values.length > 0) {
          const uniqueValues = [...new Set(params.values)];
    
          // If all values in the group are the same, return the value
          return uniqueValues.length === 1 ? uniqueValues[0] : '';
        }
        return ''; // Return empty string if values is not an array or is empty
      },
     },
    { headerName: "PAN", field: "pan", sortable: true,floatingFilter: true,filter: 'agTextColumnFilter',
      aggFunc: (params) => {
        // Check if params.values is an array and has values
        if (Array.isArray(params.values) && params.values.length > 0) {
          const uniqueValues = [...new Set(params.values)];
    
          // If all values in the group are the same, return the value
          return uniqueValues.length === 1 ? uniqueValues[0] : '';
        }
        return ''; // Return empty string if values is not an array or is empty
      },
      },
    {
      headerName: "GSTIN", 
      field: "gstin", 
      sortable: true, 
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      valueGetter: (params) => params.data ? params.data.gstin : null,
      aggFunc: (params) => {
        // Check if params.values is an array and has values
        if (Array.isArray(params.values) && params.values.length > 0) {
          const uniqueValues = [...new Set(params.values)];
    
          // If all values in the group are the same, return the value
          return uniqueValues.length === 1 ? uniqueValues[0] : '';
        }
        return ''; // Return empty string if values is not an array or is empty
      },
    },    
    { headerName: "E-invoice eligible", field: "enablement_gov.einvStatus", cellRenderer: renderEInvoice,floatingFilter: true,filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['equals'], // Allow exact match filtering
        textFormatter: (value) => {
          return value === 'Y' 
            ? 'True' 
            : value === 'N' 
            ? 'False' 
            : value === 'Einvoice Exempt' 
            ? 'Exempt' 
            : ''; // Format as True/False/Exempt
        }
      },
      
    },
  //   {
  //     headerName: "FollowUp", 
  //     field: "followUp",
  //     floatingFilter: true,
  //     filter: 'agTextColumnFilter',
  //     valueGetter: (params) => {
  //       // Safely access the value to avoid errors
  //       if (!params.data) {
  //           return ''; // Return an empty string or a default value
  //       }
  //       return params.data.followUp === 'Action req' ? 'Action req' : 'No action req';
  //   },
      
  // },  
    { headerName: "Trade name", field: "enablement_gov.tradeName", sortable: true,floatingFilter: true,filter: 'agTextColumnFilter',width:400  },
    // { headerName: "Source", field: "source", sortable: true, floatingFilter: true,filter: 'agTextColumnFilter', },
    // { headerName: "invoiceStatus", field: "invoiceStatus",hide: true },
    { headerName: "Email", field: "contactEmail"},
    { headerName: "HSN", field: "HSN", cellRenderer: renderHSN, sortable: true, floatingFilter: true, filter: 'agTextColumnFilter',width:600 },
    // { headerName: "Contact details", field: "contact", cellRenderer: renderContact,floatingFilter: true,filter: 'agTextColumnFilter',pinned: "right", },
    // { headerName: "Action", field: "action", cellRenderer: renderAction,floatingFilter: true,filter: 'agTextColumnFilter',cellStyle: { color: "#0A8394"},pinned: "right",  },
    // {
    //   headerName: "FollowUp Status",
    //   field: "followUpStatus",
    //   sortable: true,
    //   floatingFilter: true,
    //   pinned:'right',
    //   filter: 'agTextColumnFilter',
    //   valueGetter: (params) => {
    //     if (!params.data) return null;
    
    //     const { contact, Email_logs, Email_Events } = params.data;
    
    //     if (contact !== 'Completed') {
    //       return "Contact Missing";
    //     }
    
    //     if (Email_logs && Email_logs.length > 0) {
    //       if (Email_Events && Array.isArray(Email_Events)) {
    //         const openEvent = Email_Events.find(event => event.event === "open");
    //         if (openEvent) {
    //           return "Opened";
    //         }
    //       }
    //       return "Sent";
    //     }
    
    //     return "Request";
    //   },
    //   cellRenderer: (params) => {
    //     const status = params.value;
    //     const colorMap = {
    //       "Contact Missing": "#F00",
    //       "Opened": "#1F95FF",
    //       "Sent": "#0A8394",
    //       "Request": "#0A8394",
    //     };
    //     const emojiMap = {
    //       "Sent": <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    //       <path d="M13.8315 8.38336L13.8312 8.38357C13.7577 8.45659 13.6654 8.49278 13.5604 8.49278C13.4556 8.49278 13.3636 8.45651 13.2901 8.38357L13.2897 8.38314C13.2167 8.30961 13.1805 8.21732 13.1805 8.1123V5.16819L8.89757 7.97205C8.86626 7.99457 8.82365 8.01069 8.77901 8.02365C8.73086 8.03762 8.67086 8.05047 8.60004 8.06247L8.59276 8.06371H8.58537C8.53027 8.06371 8.47745 8.05776 8.42728 8.04533L8.42636 8.0451C8.37289 8.03123 8.32201 8.00637 8.27377 7.97245L3.99025 5.16819V11.1521C3.99025 11.2363 4.01647 11.2994 4.0658 11.3487C4.11513 11.3981 4.17821 11.4243 4.26244 11.4243H7.2683C7.37352 11.4243 7.46581 11.4608 7.53899 11.5345C7.6119 11.6079 7.64829 11.7001 7.64878 11.805L7.64879 11.8054C7.64878 11.9103 7.61217 12.0024 7.53877 12.0758C7.46555 12.1491 7.37333 12.1853 7.2683 12.1853H4.26244C3.97908 12.1853 3.73439 12.0832 3.5331 11.8816C3.53308 11.8815 3.53306 11.8815 3.53304 11.8815M13.8315 8.38336L3.59513 4.18039C3.40976 4.36537 3.31708 4.58781 3.31708 4.84771V11.1521C3.31708 11.412 3.40976 11.6344 3.59513 11.8194L3.53297 11.8814C3.533 11.8815 3.53302 11.8815 3.53304 11.8815M13.8315 8.38336C13.9049 8.30987 13.9415 8.21751 13.9415 8.1123V4.84771C13.9415 4.56429 13.8394 4.31955 13.6376 4.11824L13.5756 4.18039L13.6378 4.11837C13.4365 3.91664 13.1917 3.81454 12.9083 3.81454H4.26244C3.97905 3.81454 3.73433 3.91662 3.53304 4.11831M13.8315 8.38336L3.53304 4.11831M3.53304 11.8815C3.33135 11.6802 3.22927 11.4355 3.22927 11.1521V4.84771C3.22927 4.56432 3.33135 4.3196 3.53304 4.11831M3.53304 11.8815L3.53304 4.11831M10.6271 12.4732L13.688 9.41235C13.7585 9.34178 13.8465 9.30387 13.9471 9.29894C14.0543 9.29368 14.1487 9.3345 14.2266 9.41235C14.3025 9.4883 14.346 9.57879 14.346 9.68166C14.346 9.78453 14.3025 9.87502 14.2266 9.95097L11.0205 13.157C10.9107 13.2669 10.7783 13.3244 10.6271 13.3244C10.4763 13.3244 10.3441 13.2668 10.2343 13.157L10.2343 13.157L8.69011 11.6122L8.6901 11.6122L10.6271 12.4732ZM10.6271 12.4732L9.22833 11.0744C9.22828 11.0743 9.22823 11.0743 9.22817 11.0742C9.15247 10.9981 9.06193 10.9548 8.95883 10.9548C8.85632 10.9548 8.76611 10.9983 8.69031 11.074L10.6271 12.4732ZM12.7918 4.57551L8.58537 7.30981L4.37892 4.57551H12.7918Z" fill="#0A8394" stroke="#0A8394" stroke-width="0.17561"/>
    //     </svg>,
    //       "Opened": <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    //       <path d="M10.8473 4.10344C11.1107 4.30366 11.2688 4.61451 11.2688 4.94644V10.2152C11.2688 10.4947 11.1577 10.7627 10.9601 10.9603C10.7625 11.1579 10.4945 11.2689 10.215 11.2689H1.78501C1.50554 11.2689 1.23751 11.1579 1.0399 10.9603C0.842282 10.7627 0.731262 10.4947 0.731262 10.2152V4.94644C0.731262 4.78286 0.76935 4.62151 0.84251 4.47519C0.915669 4.32887 1.02189 4.2016 1.15276 4.10344L5.36776 0.942195C5.55016 0.805395 5.77201 0.731445 6.00001 0.731445C6.22801 0.731445 6.44986 0.805395 6.63226 0.942195L10.8473 4.10344Z" stroke="#1F95FF" stroke-width="0.7025" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M11.2688 4.94629L6.54269 7.94948C6.38003 8.05139 6.19196 8.10544 6.00001 8.10544C5.80806 8.10544 5.61999 8.05139 5.45733 7.94948L0.731262 4.94629" stroke="#1F95FF" stroke-width="0.7025" stroke-linecap="round" stroke-linejoin="round"/>
    //     </svg>,
    //     };
    
    //     return (
    //       <h1 style={{ 
    //         color: colorMap[status] || "#000", 
    //         fontSize: "13px", // Adjust the font size here
    //         display:'flex',
    //         alignItems:'center',
    //         gap:'6px'
    //       }}>
    //         {emojiMap[status] || ""} {status}
    //       </h1>
    //     );
    //   },
    // }
    
    
    
  ];

  const getServerSideDatasourceContactDetails = () => {
    console.log("Inside server side function")
    console.log(workspace,"in server side workspace")
    // const workSpace=workspace
    return {
      getRows: async (gridParams) => {
        console.log("[Datasource] - rows requested by grid: ", gridParams.request);
        console.log(workspace,"workspace")
    
    
        
    
        const requestBody = {
          
          ...gridParams.request,
          
   
         
          database:"gstservice",
          // table:"all_vendor_tally_data_distinct",
          // table:"all_vendor_tally_data_spark_rebuild",
          table:"vendor_contact_details",
          // table:"all_vendor_tally_data_test",
          workspaceid:"33ab7bdd-609b-4551-90b8-9becc33ccb7d",
          
        };
        console.log("Request body:", requestBody);
        try {
          const response = await fetch('https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/contactDetails', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
          });
          
          const data = await response.json();
          console.log("Data fetched:", data);
  
          
  
       
          // if (data && Array.isArray(data.data.rows)) {
            console.log("Rows from API:" ,data.data.rows )

            gridParams.success({ rowData: data.data.rows })
       
        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
    };
  };

  const   getServerSideDatasourceTwob = (workspace) => {
    console.log("Inside server side function")
    console.log(workspace, "in server side workspace")
    // const workSpace=workspace
    return {
      getRows: async (gridParams) => {
        console.log("[Datasource] - rows requested by grid: ", gridParams.request);
        let hardcodedRowGroupCols = [
          { field: 'enablement.legalNm' }  // Hardcode by vendor name or any other field you need
        ];
    
        // Check if rowGroupCols is empty or undefined, and use hardcoded value if necessary
        if (!gridParams.request.rowGroupCols || gridParams.request.rowGroupCols.length === 0) {
          gridParams.request.rowGroupCols = hardcodedRowGroupCols;  // Hardcode rowGroupCols if empty
        }
        
        let groupedColumIndex = gridParams.request.rowGroupCols.findIndex((item)=>item.field===gridParams.parentNode?.field) //3
        // console.log("groupedColumIndex",groupedColumIndex,(((gridParams.request.rowGroupCols.length-1)-groupedColumIndex)))
        const requestBody = {
          ...gridParams.request,
         
          isSecondLast:gridParams.request.rowGroupCols[groupedColumIndex+1] && gridParams.request.rowGroupCols[groupedColumIndex+1].field==="_id", //2
          database: "gstservice",
          // table:"all_vendor_tally_data_distinct",
          table: "all_vendor_tally_twob_rebuild",
          // table:"all_vendor_tally_data_test",
          workspace: "BHILOSA",
          
        };
        console.log("Request body:", requestBody);
        try {
          const response = await fetch('https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/preview_vendormanagementTwoB', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          console.log("Data fetched:", data);
          const { groupKeys, rowGroupCols } = gridParams.request;
          console.log("params data:",gridParams)
         
            gridParams.success({ rowData: data.data.rows })

      
          
        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
      columnDefs:columnDefsTwoB
   
    }
  }

  const getServerSideDatasourceTwoa = (workspace) => {
    console.log("Inside server side function")
    console.log(workspace, "in server side workspace")
    // const workSpace=workspace
    return {
      getRows: async (gridParams) => {
        console.log("[Datasource] - rows requested by grid: ", gridParams.request);
        console.log(workspace, "workspace")
        let hardcodedRowGroupCols = [
          { field: 'enablement.legalNm' }  // Hardcode by vendor name or any other field you need
        ];
    
        // Check if rowGroupCols is empty or undefined, and use hardcoded value if necessary
        if (!gridParams.request.rowGroupCols || gridParams.request.rowGroupCols.length === 0) {
          gridParams.request.rowGroupCols = hardcodedRowGroupCols;  // Hardcode rowGroupCols if empty
        }
        let groupedColumIndex = gridParams.request.rowGroupCols.findIndex((item)=>item.field===gridParams.parentNode?.field)
        const requestBody = {
          ...gridParams.request,
          isSecondLast:gridParams.request.rowGroupCols[groupedColumIndex+1] && gridParams.request.rowGroupCols[groupedColumIndex+1].field==="_id",
          database: "gstservice",
          // table:"all_vendor_tally_data_distinct",
          table: "all_vendor_tally_data_spark",
          // table:"all_vendor_tally_data_test",
          workspace: "BHILOSA",
          
        };
        console.log("Request body:", requestBody);
        try {
          const response = await fetch('https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/preview_vendormanagementTwoA', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          console.log("Data fetched:", data);
      
          
          gridParams.success({ rowData: data.data.rows })
          const { groupKeys, rowGroupCols } = gridParams.request;
          // Check if we are at the third level
          // if (gridParams.parentNode?.field==="_id" ) {
          //   console.log("params are:",gridParams)
          //   const parentRowData = gridParams.parentNode?.data;
          //   console.log("Parent Node Data (2nd Level):", parentRowData);
          //   const flattenThirdLevelData = (parentRowData) => {
          //   const thirdLevelData = parentRowData?.itms ||parentRowData?.["twoa-b2b"]?.itms?.itm_det|| [];
          //     console.log("Third Level Data:", thirdLevelData);
          //     // const gstin = parentRowData?.followupstatus?.gstin || null;
          //     return thirdLevelData.map((detail) => ({
          //       thirdLevelId: detail?.id,
          //                       camt: detail?.camt||null,
          //                       csamt: detail?.csamt|| null,
          //                       iamt: detail?.iamt || null,
          //                       rt: detail?.rt || null,
          //                       txval: detail?.txval || null,
          //                       samt: detail?.samt||null,
          //                       gstin: parentRowData.gstin,
          //                       // vendor:parentRowData.enablement.legalNm||null,
          //                       pan:parentRowData.pan,
          //                       invoiceStatus:parentRowData.invoiceStatus,
          //                        irngenData:parentRowData.irn-data,
          //                       enablement:parentRowData.enablement,
          //                       einvoiceEligibility:parentRowData.einvoiceEligibility,
          //                       inum:parentRowData.inum,
          //                       followUp:parentRowData.followUp
                                
                            
          //     }));
          //   };
            
          //   const flattenedData = flattenThirdLevelData(parentRowData);
          //   console.log("Flattened Third Level Data:", flattenedData);
          //   gridParams.success({ rowData: flattenedData });
          // }else{


            gridParams.success({ rowData: data.data.rows })

          // }
          
        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
     columnDefs:columnDefsTwoA    }
  }
  function renderAction(params) {
    if (!params.data) {
      return null; // Return null if data is missing
    }

    if (!params.data || !params.data.einvoiceEligibility || !params.data.contact || !params.data.invoiceStatus) {
          return null; // Return null if data is missing or eInvoice is not present
     }
      
        // Check if 'eInvoice' is 'Yes'
    if (params.data.einvoiceEligibility !== 'Eligible' || params.data.contact !== 'Completed'|| params.data.invoiceStatus !== 'Invoice Not Received' ) {
      return null; // Don't render anything if eInvoice is not 'Yes'
    }
  
    // Extract email-related data
    const { Email_logs, Email_Events } = params.data;


    if (!Email_logs && !Email_Events) {
      return (
        <button className="action-button">
          Send Mail
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path
              d="M14.6666 5.83333L6.33325 14.1667M14.6666 5.83333H7.16659M14.6666 5.83333V13.3333"
              stroke="#0A8394"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      );
    }


     // If Email_Events exists and contains an event of type "open", show "Mail Opened"
     if (Email_Events && Array.isArray(Email_Events)) {
      const openEvent = Email_Events.find(event => event.event === "open");
      if (openEvent) {
        return (
          <button className="action-tick">
            📬 Mail Opened
          </button>
        );
      }
    }
  
    const emailStatus = params.data.action || 'Send Mail';
  
    // If Emailstatus is 'Mail Sent', display a tick emoji
    if (emailStatus === 'Mail Sent') {
      return (
        <button className="action-tick">
          ✅ Mail Sent
        </button>
      );
    }
  
   
  
    // Default to "Send Mail" if no Email_logs or Email_Events
    return (
      <button className="action-button">
        Send Mail
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M14.6666 5.83333L6.33325 14.1667M14.6666 5.83333H7.16659M14.6666 5.83333V13.3333"
            stroke="#0A8394"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    );
  }
  

  // useEffect(() => {
  //   // Fetch vendor data
  //   setLoading(true);
  //   axios.get(`/vendor-data?workspace=${workspace}`)
  //     .then(response => {
  //       const vendorList = response.data.map(vendor => ({
  //         vendorName: vendor.enablement?.legalNm || '',
  //         tradeName: vendor.enablement?.tradeNm || '',
  //         gstin: vendor.ctin,
  //         pan: vendor.pan,
  //         einvoiceEligibility: vendor.einvoiceEligibility,
  //         invoiceStatus: vendor.invoiceStatus, 
  //         source: '2B',
  //         contact: vendor.contact || 'Contact', // Default value for contact
  //         action: vendor.Emailstatus || 'Send Mail',
  //         invoiceNumber: vendor['two-a-flat']?.nt_num || '', // Access using bracket notation
  //         invoiceDate: vendor['two-a-flat']?.nt_dt || '', // Access using bracket notation
  //         Hsn_Irn: vendor.Hsn_Irn || [] ,
  //         HSN: vendor.HSN || {}, // Include HSN data from the API response\
  //         Email_logs: vendor.Email_logs || [],
  //         Email_Events: vendor.Email_Events || [],
  //         totalgstamount : vendor.totalGstAmount || '',
  //         followUp: (vendor.einvoiceEligibility === 'Eligible' && vendor.invoiceStatus === 'Invoice Not Received') 
  //         ? 'Action req' 
  //         : 'Not Required',
  //       }));

  //       setTotalVendors(vendorList.length); // Set total vendors count

  //       // Calculate compliant and non-compliant vendors
  //       const compliant = vendorList.filter(
  //         vendor => vendor.invoiceStatus === "Invoice Received" && vendor.einvoiceEligibility === "Eligible"
  //       ).length;
  //       setCompliantVendors(compliant);

  //       const nonCompliant = vendorList.filter(
  //         vendor => vendor.invoiceStatus === "Invoice Not Received" && vendor.einvoiceEligibility === "Eligible"
  //       ).length;
  //       setNonCompliantVendors(nonCompliant);

  //       // Fetch contact data
  //       axios.get(`/get-contacts?workspace=${workspace}`)
  //         .then(contactResponse => {
  //           const contactData = contactResponse.data;

  //           setContactData(contactData); 

  //           // Update missing contact count
  //           const missingContacts = vendorList.filter(vendor => 
  //             !contactData.find(contact => contact.gstin === vendor.gstin  && contact.vendorName === vendor.vendorName)
  //           );
  //           setMissingContactCount(missingContacts.length); // Set missing contacts count

  //           // Map vendor data with contact data
  //           const updatedVendorData = vendorList.map(vendor => {
  //             const contactMatch = contactData.find(contact => 
  //              contact.gstin === vendor.gstin
  //             );

  //             if (contactMatch) {
  //               vendor.contact = 'Completed';
  //               vendor.email = contactMatch.contactEmail || ''; 
                
  //             }
              

  //             return vendor;
  //           });


            

  //           setVendorData(updatedVendorData); // Update the state with vendor data
  //           setAllVendorData(updatedVendorData); 
  //           setLoading(false);
  //         })
  //         .catch(contactError => {
  //           console.error('Error fetching contact data:', contactError);
  //         });

  //     })
  //     .catch(error => {
  //       console.error('Error fetching vendor data:', error);
  //     });
  // }, [workspace]);

  // useEffect(() => {
  //   setLoading(true);

  //   // Fetch Vendor Data only once
  //   axios.get(`https://fuzzyapi.finkraftai.comvendor-data?workspace=${workspace}`)
  //     .then(response => {
  //       const vendorList = response.data.map(vendor => ({
  //         vendorName: vendor.enablement?.legalNm || '',
  //         tradeName: vendor.enablement?.tradeNm || '',
  //         gstin: vendor.ctin,
  //         pan: vendor.pan,
  //         einvoiceEligibility: vendor.einvoiceEligibility,
  //         invoiceStatus: vendor.invoiceStatus,
  //         source: '2B',
  //         contact: vendor.contact || 'Contact', // Default value for contact
  //         action: vendor.Emailstatus || 'Send Mail',
  //         invoiceNumber: vendor['two-a-flat']?.nt_num || '',
  //         invoiceDate: vendor['two-a-flat']?.nt_dt || '',
  //         Hsn_Irn: vendor.Hsn_Irn || [],
  //         HSN: vendor.HSN || {},
  //         Email_logs: vendor.Email_logs || [],
  //         Email_Events: vendor.Email_Events || [],
  //         totalgstamount: vendor.totalGstAmount || '',
  //         followUp: (vendor.einvoiceEligibility === 'Eligible' && vendor.invoiceStatus === 'Invoice Not Received')
  //           ? 'Action req'
  //           : 'Not Required',
  //       }));

  //       setTotalVendors(vendorList.length);

  //       const compliant = vendorList.filter(
  //         vendor => vendor.invoiceStatus === "Invoice Received" && vendor.einvoiceEligibility === "Eligible"
  //       ).length;
  //       setCompliantVendors(compliant);

  //       const nonCompliant = vendorList.filter(
  //         vendor => vendor.invoiceStatus === "Invoice Not Received" && vendor.einvoiceEligibility === "Eligible"
  //       ).length;
  //       setNonCompliantVendors(nonCompliant);

  //       setVendorData(vendorList);
  //       setLoading(false);
  //     })
  //     .catch(error => {
  //       console.error('Error fetching vendor data:', error);
  //     });


      const currentWorkspace = localStorage.getItem('currentWorkspace');
  

  //   // Fetch Contact Data only once
  //   axios.get(`https://fuzzyapi.finkraftai.com/get-contacts?workspace=${currentWorkspace}`)
  //     .then(contactResponse => {
  //       setContactData(contactResponse.data);

  //       // Map the contact data to GST data format
  //       const gstList = contactResponse.data.map(contact => ({
  //         vendorName: contact.vendorName,
  //         gstin: contact.gstin,
  //         vendorName: contact.vendorName,
  //         pan: contact.pan,
  //         contactEmail: contact.contactEmail,
  //         einvoiceEligibility:contact.enablement_gov?.einvStatus,
  //         HSN : contact.HSN || {},
  //       }));

  //       setGstData(gstList);
  //       setTotalGSTRows(gstList.length);
  //     })
  //     .catch(contactError => {
  //       console.error('Error fetching contact data:', contactError);
  //     });

  // }, [workspace]); // Only fetch data once when workspace changes


  function renderContact(params) {
    if (params.value === "Completed") {
      return (
        <span className="contact-status completed">
          Completed
        </span>
      );
    } else if (params.value === "Pending") {
      return (
        <span className="contact-status pending">
          Pending
        </span>
      );
    } else if (params.value === "Contact") {
      return (
        <span className="contact-status contact">
    Add contact
        </span>
      );
    } else {
      return null;
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vendorValue, setVendorValue] = useState("");
  const [totalGstAmount,setTotalGstAmount]= useState('')

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);



  const navigate = useNavigate();
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [gstin, setGstin] = useState(null); // State to store gstin


  const calculateInvoiceData = (gstin) => {
    // Filter rowData to get all invoices for the selected GSTIN
    const invoicesForGstin = vendorData.filter((row) => row.gstin === gstin);
  
    // Calculate total number of invoices
    const totalInvoices = invoicesForGstin.length;
  
    // Calculate number of invoices received and not received
    const receivedInvoices = invoicesForGstin.filter((row) => row.invoiceStatus === "Invoice Received").length;
    const notReceivedInvoices = invoicesForGstin.filter((row) => row.invoiceStatus === "Invoice Not Received").length;
  
    // Calculate percentages
    const receivedPercentage = totalInvoices > 0 ? (receivedInvoices / totalInvoices) * 100 : 0;
    const notReceivedPercentage = totalInvoices > 0 ? (notReceivedInvoices / totalInvoices) * 100 : 0;
  
    // Return the invoice data
    return {
      totalInvoices,
      receivedInvoices, // Count of received invoices
      notReceivedInvoices, // Count of not received invoices
      receivedPercentage,
      notReceivedPercentage
    };
  };
  
  const [invoicesData, setInvoicesData] = useState({
    totalInvoices: 0,
    receivedInvoices: 0,
    notReceivedInvoices: 0,
    receivedPercentage: 0,
    notReceivedPercentage: 0
  });
  
  


  


  const handleCellClick = (event) => {
    const { colDef, data } = event;
  
    // Navigate on clicking "Vendor name"
    if (colDef.field === "vendorName") {
      const { gstin,totalgstamount } = data;
      console.log("gstin",gstin);
      
      const invoiceData = calculateInvoiceData(gstin);
      console.log(invoiceData)
       
       setGstin(gstin); 
       setTotalGstAmount(totalgstamount)
       setInvoicesData(invoiceData);
       setIsSideMenuOpen(true); // Open the side menu

      // navigate(`/vendorfollowup/vendorscore?vendorName=${vendorName}&pan=${pan}&gstin=${gstin}`);
    }
  
    // Open modal on clicking "Contact" column if status is "Contact"
    if (colDef.field === "contact" && event.value === "Contact") {
      setVendorValue(data.vendorName);
      openModal();
    }
  
    // Navigate on clicking "Action" column
    // Navigate on clicking "Action" column
if (colDef.field === "action") {
  console.log("action clicked");

  const { contact, einvoiceEligibility, gstin, vendorName, invoiceNumber, invoiceDate, action } = data;

  // Only open the modal if action is "Send Mail"
  if (action === "Send Mail") {
    if (contact === "Completed" && einvoiceEligibility === "Eligible") {
      // Find the email based on GSTIN
      const contactDetail = contactData.find(contact => contact.gstin === gstin);
      console.log("contactDetails:", contactDetail);

      if (contactDetail) {
        setSelectedEmail(contactDetail.contactEmail); // Set email state
        console.log(vendorName);
        setSelectedVendor(vendorName);
        setSelecteGstin(gstin);
        setSelectedIN(invoiceNumber);
        setSelectedID(invoiceDate);
        openEmailModal();
      } else {
        console.error("No contact details found for GSTIN:", gstin);
      }
    }
  } else {
    console.log("Action is not 'Send Mail', modal will not open.");
  }
}

  };

  // function renderEInvoice1(params) {
  //   if (params.value === 'Y') {
  //     return (
  //       <span className="eligiblestatus">
  //         <span className="dot green"></span> True
  //       </span>
  //     );
  //   } else if (params.value === 'N') {
  //     return (
  //       <span className="eligiblestatus">
  //         <span className="dot red"></span> False
  //       </span>
  //     );
  //   }
  //   else if (params.value === 'Einvoice Exempt') {
  //     return (
  //       <span className="eligiblestatus">
  //         <span className="dot orange"></span> Exempt
  //       </span>
  //     );
  //   }
  //   return null; // Default case when value is not 'Yes' or 'No'
  // }

  function renderEInvoice1(params) {
    // Check if the row is not a group and has a valid parent
    if (params.node.group && params.node.parent) {
      const cellValue = params.data?.einvoiceEligibility; // Value for child rows
      if (cellValue === 'Eligible') {
        return (
          <span className="eligiblestatus">
            <span className="dot green"></span> Eligible
          </span>
        );
      } else if (cellValue === 'Not Eligible') {
        return (
          <span className="eligiblestatus">
            <span className="dot red"></span> Not Eligible
          </span>
        );
      } else if (cellValue === 'Exempted') {
        return (
          <span className="eligiblestatus">
            <span className="dot orange"></span> Exempted
          </span>
        );
      }
      return null; // Default case for child rows
    }
  
    // Default for parent rows or non-expanded groups
    return null;
  }






  

  function renderEInvoice(params) {
    if (params.value === 'Y') {
      return (
        <span className="eligiblestatus">
          <span className="dot green"></span> True
        </span>
      );
    } else if (params.value === 'N') {
      return (
        <span className="eligiblestatus">
          <span className="dot red"></span> False
        </span>
      );
    }
    else if (params.value === 'Einvoice Exempt') {
      return (
        <span className="eligiblestatus">
          <span className="dot orange"></span> Exempt
        </span>
      );
    }
    return null; // Default case when value is not 'Yes' or 'No'
  }
  
  const closeSideMenu = () => {
    setIsSideMenuOpen(false); // Close the side menu
    // setSelectedVendor(null);
};
  
  

  
  const defaultColDef = {
    filter: true,
    sortable: true,
    enableRowGroup: true,
    floatingFilter: true,
    // noConfigCheck: true,
    // columnGroupShow: "open",
    // extractionType: "TEXT",
    // extractionPlace: "SELF",
  };

  
  const gridOptions = {
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
        {
          id: "pdf viewer",
          labelDefault: "View",
          labelKey: "view",
          iconKey: "pdfIcon",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: "right",
    },

    icons: {
      pdfIcon: `<svg xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
      </svg>`,
    },
  };


  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Prepare the form data to be sent to the backend
    const formData = {
      vendorName: vendorValue,
      pan: vendorData.find((vendor) => vendor.vendorName === vendorValue)?.pan,
      gstin: vendorData.find((vendor) => vendor.vendorName === vendorValue)?.gstin,
      contactName,
      contactEmail,
      contactNumber,
      roleType,
      workspace
    };

    // Send the form data to the backend
    axios.post('https://fuzzyapi.finkraftai.com/add-contact', formData)
      .then(response => {
        console.log('Contact added successfully:', response);

        // Find the vendor and update the 'contact' field to 'Completed'
        const updatedVendorData = vendorData.map((vendor) => {
          if ( vendor.gstin === formData.gstin && vendor.vendorName === formData.vendorName ) {
            return { ...vendor, contact: 'Completed' }; // Update the 'contact' field
          }
          return vendor; // Keep other vendors unchanged
        });

        // Update the state with the modified vendorData
        setVendorData(updatedVendorData);

        // Close the modal after successful submission
        closeModal();
      })
      .catch(error => {
        console.error('Error adding contact:', error);
      });
};



  const onSearchChange = (e) => {
    setSearchText(e.target.value); // Update search text state

    // If search box is cleared, reset the vendor data to the original list
    if (e.target.value === '') {
      setVendorData(allVendorData);
    } else {
      // Filter vendor data based on vendorName
      const filteredData = allVendorData.filter((vendor) =>
        vendor.vendorName.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setVendorData(filteredData); // Update the displayed vendor data
    }
  };



  const handleSubmitFile = (file) => {
    console.log("File submitted:", file);
  
    // Process the response data (file.data contains the rows from the file)
    const updatedVendorData = vendorData.map((vendor) => {
      // Check if the current vendor matches the formData (this could be one of the rows from file)
      const match = file.data.find(
        (row) => vendor.gstin === row.gstin && vendor.enablement?.legalNm === row.vendorName
      );
  
      if (match) {
        console.log("Match found for:", { vendor, match });
  
        // If match is found and the contact is not 'Completed', update it
        if (vendor.contact !== "Completed") {
          console.log(`Updating vendor with GSTIN: ${vendor.gstin}, Vendor Name: ${vendor.enablement?.legalNm}`);
          return { ...vendor, contact: "Completed" }; // Update the 'contact' field
        }
      }
  
      return vendor; // Keep other vendors unchanged
    });
  
    // Update the state with the modified vendorData
    setVendorData(updatedVendorData);

    // // Add the entire file.data (contact details) to the contactData state
    // setContactData((prevContactData) => [
    //   ...prevContactData,
    //   ...file.data
    // ]);
  
  
    // Close the modal
    setUploadContactsModalOpen(false); // Close the modal after update
  };
  


  const goBack = () => {
    navigate(-1); // This will navigate the user back to the previous page
  };

  

  
  const printExpandedRowData = (expandedData) => {
    // Custom logic to format and print the data
    console.log("Printing Expanded Row Data:", expandedData);
  
    // For example, log to the console or trigger a print dialog
    expandedData.forEach((data) => {
      console.log(data);
    });
  };

  useEffect(() => {
    if (selectedWorkspace) {
      sessionStorage.setItem("selectedWorkspace", selectedWorkspace);
      setWorkspace(selectedWorkspace)
    }
  }, [selectedWorkspace]);


  useEffect(() => {
    // Fetch workspace data on mount
    const fetchUserInfo = async () => {
      try {
        const response = await apiGet(API_ENDPOINT_GET_USER_INFO, false);
        console.log("API Response:", response);
        if (response.status && response.data?.workspaces) {
          setWorkspaces(response.data.workspaces);
          setFilteredOptions(response.data.workspaces); // Initialize filtered options
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchUserInfo();
  }, []);


  // Filter options based on the search query
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setFilteredOptions(
      workspaces.filter((workspace) =>
        workspace.name.toLowerCase().includes(query)
      )
    );
  };

  // Handle selection of a workspace
  const handleSelectOption = (workspace) => {
    setSelectedWorkspace(workspace.name);
    setIsDropdownOpen(false);
    setSearchQuery("");
    setFilteredOptions(workspaces); // Reset the filtered options
    
          // Dispatch a custom event to notify other pages
    const event = new CustomEvent('workspaceChanged', {
      detail: workspace.name
    });
    window.dispatchEvent(event);
  };


  const [gstAmountData, setGstAmountData] = useState(null);



  useEffect(() => {
    // Define the API URL
    const apiUrl = 'https://fuzzyapi.finkraftai.com/sum-gst-eligible';

    // Call the API
    const fetchGstData = async () => {
      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ workspaceName: workspace }), // Send workspace name in the payload
        });

        if (response.ok) {
          const data = await response.json();
          setGstAmountData(data); // Store the response data
        } else {
          console.error('Failed to fetch GST data');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchGstData();
  }, [workspace]);
  
  const [vendorGstinList, setVendorGstinList] = useState([]); // State to store vendor and GSTIN list

  const onSelectionChanged = () => {
    if (!gridApi) return; // Check if gridApi is defined
  
    // Get the selected rows
    const selectedRows = gridApi.getSelectedRows();
    // setSelectedRowsCount(selectedRows.length);
  
    // Extract vendor name and GSTIN as a list of objects
    const extractedList = selectedRows.map(vendorData => ({
      vendorName: vendorData.enablement?.legalNm, // Adjust field path as needed
      gstin: vendorData.gstin,
    }));
  
    console.log('extractedList',extractedList)
  
    // Update state with the extracted list
    setVendorGstinList(extractedList);
  
    // Update button text based on selection
    if (selectedRows.length > 0) {
      // setSelectAllText("Request E-Invoice");
    } else {
      // setSelectAllText("Select All");
    }
  };
  const [totalRows, setTotalRows] = useState(0);


  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);

    // setTotalRowsCount(rowData.length);
    params.api.addEventListener('selectionChanged', onSelectionChanged);
  };

  // Function to dynamically apply row grouping for "Vendor Name"
  const applyRowGrouping = () => {
    if (gridApi) {
      gridApi.setRowGroupColumns(["enablement.legalNm"]);
    }
  };

  // Toggle function to switch between tables
  // const toggleTable = () => {
  //   setIsVendorManagement(!isVendorManagement);
  //   setTotalRows(isVendorManagement ? totalGSTRows : totalVendors);
  // };

  const toggleTable = () => {
    if (isVendorManagement) {
      setIsVendorManagement(false);
      setIsContactDetails(true); // Switch to Contact Details
    } else {
      setIsVendorManagement(false);
      setIsContactDetails(true); // Switch to Vendor Management
    }
    setTotalRows(isVendorManagement ? totalGSTRows : totalVendors);
  };


  
  return (
    <>
    <div className="vendor-management">
  
      <header className="vendor-header">
        <div className="vendor-left">
        <button className="vendor-back-btn" onClick={goBack}><svg xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M17.0305 10.7422L5.60281 10.7422L12.4427 16.6797C12.552 16.7754 12.4856 16.9531 12.3411 16.9531H10.6126C10.5364 16.9531 10.4641 16.9258 10.4075 16.877L3.02664 10.4727C2.95904 10.4141 2.90482 10.3416 2.86767 10.2602C2.83051 10.1789 2.81128 10.0904 2.81128 10.001C2.81128 9.91151 2.83051 9.8231 2.86767 9.74172C2.90482 9.66034 2.95904 9.58789 3.02664 9.5293L10.4505 3.08594C10.4798 3.06055 10.5149 3.04688 10.552 3.04688L12.3391 3.04687C12.4837 3.04687 12.5501 3.22656 12.4407 3.32031L5.60281 9.25781L17.0305 9.25781C17.1165 9.25781 17.1868 9.32812 17.1868 9.41406V10.5859C17.1868 10.6719 17.1165 10.7422 17.0305 10.7422Z" fill="#0A8394"/>
</svg></button>  
<div className="toggle-buttons">
  <div className="toggle-container">
    <label className="toggle-switch">
      <input type="checkbox" checked={isVendorManagement} onChange={toggleTable} />
      <div className="toggle-slider">
        {/* <span className={`toggle-text ${isVendorManagement ? 'enabled' : ''}`}>Vendor Management</span> */}
        <span className={`toggle-text ${!isVendorManagement ? 'enabled' : ''}`}>Contact Details</span>
        
      </div>

    </label>
  </div>
  <button 
  onClick={openUploadContactsModal} 
  className="vendor-btn" 
  style={{
    display: 'inline-flex',  // Align items horizontally
    alignItems: 'center',    // Vertically align items in the center
    backgroundColor: '#e6f7f9',
    border: '1px solid #0a8394',
    color: '#0a8394',
    padding: '8px 12px',
    paddingLeft: '10px',
    borderRadius: '5px',
    fontSize: '14px',
    marginLeft:'10px',
    cursor: 'pointer',
    gap: '5px',              // Adds space between the icon and the text
    transition: 'background-color 0.3s ease'
  }}
>
  <svg xmlns="https://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path d="M10.5001 4.16666V15.8333M4.66675 9.99999H16.3334" stroke="#0A8394" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg> 
  Add Contact
</button>
</div>





        {/* Toggle Switch */}
     
        {/* <div className="vendor-search-container">
      <input type="text" placeholder="Search" className="vendor-search-bar" value={searchText}
        onChange={onSearchChange}/>
      <svg xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="vendor-search-icon">
        <path d="M17.7656 16.6895L12.6934 11.6172C13.4805 10.5996 13.9062 9.35547 13.9062 8.04688C13.9062 6.48047 13.2949 5.01172 12.1895 3.9043C11.084 2.79687 9.61133 2.1875 8.04688 2.1875C6.48242 2.1875 5.00977 2.79883 3.9043 3.9043C2.79687 5.00977 2.1875 6.48047 2.1875 8.04688C2.1875 9.61133 2.79883 11.084 3.9043 12.1895C5.00977 13.2969 6.48047 13.9062 8.04688 13.9062C9.35547 13.9062 10.5977 13.4805 11.6152 12.6953L16.6875 17.7656C16.7024 17.7805 16.72 17.7923 16.7395 17.8004C16.7589 17.8084 16.7797 17.8126 16.8008 17.8126C16.8218 17.8126 16.8427 17.8084 16.8621 17.8004C16.8815 17.7923 16.8992 17.7805 16.9141 17.7656L17.7656 16.916C17.7805 16.9011 17.7923 16.8835 17.8004 16.864C17.8084 16.8446 17.8126 16.8238 17.8126 16.8027C17.8126 16.7817 17.8084 16.7609 17.8004 16.7414C17.7923 16.722 17.7805 16.7043 17.7656 16.6895ZM11.1406 11.1406C10.3125 11.9668 9.21484 12.4219 8.04688 12.4219C6.87891 12.4219 5.78125 11.9668 4.95312 11.1406C4.12695 10.3125 3.67188 9.21484 3.67188 8.04688C3.67188 6.87891 4.12695 5.7793 4.95312 4.95312C5.78125 4.12695 6.87891 3.67188 8.04688 3.67188C9.21484 3.67188 10.3145 4.125 11.1406 4.95312C11.9668 5.78125 12.4219 6.87891 12.4219 8.04688C12.4219 9.21484 11.9668 10.3145 11.1406 11.1406Z" fill="#C3C4CD"/>
      </svg>
    </div> */}
     {/* <div className="vendorfollowup-dropdown-container">
      <div
        className={`vendorfollowup-dropdown-header ${
          isDropdownOpen ? "active" : ""
        }`}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {selectedWorkspace || "Select a workspace"}
        <span className="vendorfollowup-dropdown-icon">
          {isDropdownOpen ? "▲" : "▼"}
        </span>
      </div>

      {isDropdownOpen && (
        <div className="vendorfollowup-dropdown-body">
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search workspaces..."
            className="vendorfollowup-dropdown-search"
          />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((workspace) => (
              <div
                key={workspace.id}
                className="vendorfollowup-dropdown-item"
                onClick={() => handleSelectOption(workspace)}
              >
                {workspace.name}
              </div>
            ))
          ) : (
            <div className="vendorfollowup-dropdown-item no-options">
              No workspaces found
            </div>
          )}
        </div>
      )}
    </div> */}
        </div>
        {/* <div className="vendor-right">
            <button onClick={openUploadContactsModal} className="vendor-btn"><svg xmlns="https://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
  <path d="M10.5001 4.16666V15.8333M4.66675 9.99999H16.3334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Upload Contacts</button>
        </div>  */}

      
       
          <div className="vendorfollowup-dropdown-container">
          {isVendorManagement&&(

<div className="vendor-right">
     <div >
    <label style={{
      position: 'relative',
      display: 'inline-block',
      width: '200px', /* Adjust width for both names */
      height: '30px',
      backgroundColor: '#ffffff', /* White background */
      borderRadius: '10px',
      border: '2px solid #0A8394', /* Light green border */
      cursor: 'pointer',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', /* Subtle shadow */
      overflow: 'hidden'
    }}>
      <input type="checkbox" checked={is2A} onChange={toggleTableTwoATwoB} style={{ display: 'none' }} />
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        height: '100%',
        width: '100%',
        fontFamily: 'Arial, sans-serif',
        fontSize: '13px',
        fontWeight: '600'
      }}>
        <span style={{
          flex: '1',
          textAlign: 'center',
          color: is2A ? '#ffffff' : '#000', /* Default text color */
          backgroundColor: is2A ? '#0A8394' : 'transparent', /* Light green background */
          borderRadius: '50px',
          padding: '10px 20px',
          transition: 'all 0.3s ease'
        }}>
          2A
        </span>
        <span style={{
          flex: '1',
          textAlign: 'center',
          color: !is2A ? '#ffffff' : '#000', /* Default text color */
          backgroundColor: !is2A ? '#0A8394' : 'transparent', /* Light green background */
          borderRadius: '50px',
          padding: '10px 20px',
          transition: 'all 0.3s ease'
        }}>
          2B
        </span>
      </div>
    </label>
  </div>
     {/* <button onClick={openUploadContactsModal} className="vendor-btn"><svg xmlns="https://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
  <path d="M10.5001 4.16666V15.8333M4.66675 9.99999H16.3334" stroke="#0A8394" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Add Contact</button>
<button onClick={onSelectAllClick} style={{ padding: "5px 10px", marginRight: '10px' }} className="groupby-btn">
  {selectAllText === "Select All" ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path d="M7.75 12L12.75 17L22.75 7M2.75 12L7.75 17M12.75 12L17.75 7" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path d="M10.75 14L21.75 3M10.75 14L14.25 21C14.2939 21.0957 14.3643 21.1769 14.453 21.2338C14.5416 21.2906 14.6447 21.3209 14.75 21.3209C14.8553 21.3209 14.9584 21.2906 15.0471 21.2338C15.1357 21.1769 15.2061 21.0957 15.25 21L21.75 3M10.75 14L3.75001 10.5C3.65427 10.4561 3.57314 10.3857 3.51626 10.2971C3.45938 10.2084 3.42914 10.1053 3.42914 10C3.42914 9.89469 3.45938 9.79158 3.51626 9.70295C3.57314 9.61432 3.65427 9.54388 3.75001 9.5L21.75 3" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )}
  {selectAllText}
</button> */}

      {/* <button onClick={applyRowGrouping} style={{ padding: "5px 10px" }} className="groupby-btn">
        Group by Vendor Name
      </button> */}
      </div>
      )}
      {/* <div
        className={`vendorfollowup-dropdown-header ${
          isDropdownOpen ? "active" : ""
        }`}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {selectedWorkspace || "Select a workspace"}
        <span className="vendorfollowup-dropdown-icon">
          {isDropdownOpen ? "▲" : "▼"}
        </span>
      </div> */}

      {/* {isDropdownOpen && (
        <div className="vendorfollowup-dropdown-body">
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search workspaces..."
            className="vendorfollowup-dropdown-search"
          />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((workspace) => (
              <div
                key={workspace.id}
                className="vendorfollowup-dropdown-item"
                onClick={() => handleSelectOption(workspace)}
              >
                {workspace.name}
              </div>
            ))
          ) : (
            <div className="vendorfollowup-dropdown-item no-options">
              No workspaces found
            </div>
          )}
        </div>
      )} */}
    </div>
      </header>
      {/* <div className="vendor-cards">
        <div className="vendor-card">
     <h4>{totalRows}</h4>
     <p>Total Vendors</p>
          
        </div>
        <div className="vendor-card">
          <h4>{compliantVendors}</h4>
          <p>Compliant vendors</p>
        </div>
        <div className="vendor-card">
          <h4>{nonCompliantVendors}</h4>
          <p>Non-compliant vendors</p>
        </div>
        <div className="vendor-card">
          <h4>{missingContactCount}</h4>
          <p>Missing vendors contact</p>
        </div>
      </div> */}
      <div className="ag-theme-alpine table-container" style={{ height: "80vh", width: '100%', }}>
      <AgGridReact
          rowData={isVendorManagement ? vendorData : gstData}
          // columnDefs={isVendorManagement ? columnDefs : gstColumnDefs}
          columnDefs={columnDefs}
          rowModelType="serverSide"
          groupPanel
          gridOptions={gridOptions}
          rowGroupPanelShow="always"
          defaultColDef={defaultColDef}
          rowSelection="multiple"
          enableSorting={true}
          enableFilter={true}
          masterDetail={true}
          groupSelectsChildren={true}
          onCellClicked={handleCellClick}
          onRowGroupOpened={onRowGroupOpened}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          detailCellRendererParams={{
            detailGridOptions: {
              columnDefs: detailColumnDefs,
            },
            getDetailRowData: getDetailRowData,
          }}
        />
      </div>
      <UploadContactsModal
  isOpen={isUploadContactsModalOpen}
  onClose={closeUploadContactsModal}
  onSubmit={handleSubmitFile}
  selectedVendorNamesAndGstin={vendorGstinList}
  sampleCsvPath="/vendor_contact_details.csv"
/>

{isSideMenuOpen && (
      <div className="side-menu">
          <button className="close-btn" onClick={closeSideMenu}>
              &times;
          </button>
          <MainContentVendor  gstin={gstin} invoicesData={invoicesData} totalGstAmount={totalGstAmount} />
      </div>
  )}



      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          style={{
            content: {
              width: '400px',
              height: '400px',
              margin: 'auto',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              border: '1px solid #ddd',
              padding: '30px',
            },
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ marginBottom: '10px', fontWeight: '500' }}>Add {vendorValue} Contact</h2>
            <button
              onClick={closeModal}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: '18px',
                cursor: 'pointer',
                color: '#0A8394',
              }}
            >
              ✕
            </button>
          </div>
          <form onSubmit={handleFormSubmit}>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontWeight: '400', marginBottom: '5px', color: '#212121' }}>Name</label>
              <input
                type="text"
                value={contactName}
                onChange={(e) => setContactName(e.target.value)}
                placeholder="Enter name here"
                style={{
                  width: '95%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontWeight: '400', marginBottom: '5px', color: '#212121' }}>Email Id</label>
              <input
                type="email"
                value={contactEmail}
                onChange={(e) => setContactEmail(e.target.value)}
                placeholder="Enter email address"
                style={{
                  width: '95%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontWeight: '400', marginBottom: '5px', color: '#212121' }}>Contact number</label>
              <input
                type="text"
                value={contactNumber}
                onChange={(e) => setContactNumber(e.target.value)}
                placeholder="Enter number here"
                style={{
                  width: '95%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontWeight: '400', marginBottom: '5px', color: '#212121' }}>Role</label>
              <input
                type="text"
                value={roleType}
                onChange={(e) => setRoleType(e.target.value)}
                placeholder="Enter role here"
                style={{
                  width: '95%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px",width:'100%',}}>
              <button
                type="button"
                onClick={closeModal}
                style={{
                  padding: "10px 20px",
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  cursor: "pointer",
                  width:'60%'
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={{
                  padding: "10px 20px",
                  background: "#0A8394",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  width:'60%',
                  marginLeft:'10px',
                  display:'flex',
                  justifyContent:'center',
                  alignItems:'center'
                }}
              >
                <svg xmlns="https://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 20" fill="none">
  <path d="M10.5001 4.16666V15.8333M4.66675 9.99999H16.3334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Add
              </button>
            </div>

          </form>
        </Modal>
      )}
    </div>
    </>
  );
};

export default VendorFollowupList;